var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 262,
    viewBox: "0 0 203 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 136,
    height: 260,
    rx: 11,
    stroke: "#212429",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 44,
    width: 108,
    height: 22,
    rx: 4,
    fill: "#DEE1E6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 75,
    width: 85,
    height: 42,
    rx: 4,
    fill: "#E9EDF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 128,
    width: 85,
    height: 42,
    rx: 4,
    fill: "#CFD4DA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 179,
    width: 108,
    height: 42,
    rx: 4,
    fill: "#F2F3F7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 81,
    width: 156,
    height: 98,
    rx: 4,
    fill: "#3681D3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 149,
    width: 5,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 149,
    width: 5,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 149,
    width: 5,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 149,
    width: 5,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 107,
    width: 24,
    height: 5,
    rx: 0.5,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 98,
    width: 24,
    height: 5,
    rx: 0.5,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 98,
    width: 24,
    height: 5,
    rx: 0.5,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 84,
    r: 29,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159 47.333C138.796 47.333 122.333 63.7963 122.333 83.9997C122.333 104.203 138.796 120.666 159 120.666C179.203 120.666 195.666 104.203 195.666 83.9997C195.666 63.7963 179.203 47.333 159 47.333ZM176.526 75.5663L155.736 96.3563C155.223 96.8697 154.526 97.163 153.793 97.163C153.06 97.163 152.363 96.8697 151.85 96.3563L141.473 85.9797C140.41 84.9163 140.41 83.1563 141.473 82.093C142.536 81.0297 144.296 81.0297 145.36 82.093L153.793 90.5263L172.64 71.6797C173.703 70.6163 175.463 70.6163 176.526 71.6797C177.59 72.743 177.59 74.4663 176.526 75.5663Z",
    fill: "#61CB0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPayment);
export default __webpack_public_path__ + "static/media/success-payment.b9d70abb7bcbbc8b1472637c974e0224.svg";
export { ForwardRef as ReactComponent };